export default "__VITE_ASSET__cBJwdAw8__"